import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/MenuOutlined";
import { useAppSelector } from "../../../Redux/hooks";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export const SurveyHeader = ({ setShowDrawer, packageName }: any) => {
  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:900px)");
  const isFieldSubmitting = useAppSelector(
    (state) => state.response.fieldSubmitting
  );

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        height: "80px",
        px: 3,
        py: 2,
        border: { xs: "1px solid #E5E7EB", md: "none" },
        "& .header-logo": {
          maxWidth: "258px",
          maxHeight: "60px",
        },
        backgroundColor: "#FFF",
      }}
      gap={3}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {isMobile && (
          <IconButton
            aria-label="menu"
            size="large"
            onClick={() => setShowDrawer(true)}
          >
            <MenuIcon fontSize="inherit" />
          </IconButton>
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {!isMobile && (
            <IconButton onClick={handleBack}>
              <ChevronLeft />
            </IconButton>
          )}
          <Typography fontSize={20} fontWeight={600} color="text.primary">
            {packageName || ""}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {isFieldSubmitting && <CircularProgress color="primary" size={24} />}
      </Box>
    </Stack>
  );
};
